import React from 'react';
import { Ticket } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';
import { Skeleton } from '../../components/ui/skeleton';

export const SeasonTicketsCard = ({ summary, prefix, loading = false, className = '' }) => <Card className={className} data-testid={`${prefix}-card`}>
  <CardContent className="p-4 grid grid-cols-1 sm:grid-cols-4 gap-4">
    <div className="min-w-0">
      <div className="flex items-center gap-2 text-sm font-medium text-muted-foreground"><Ticket className="w-4 h-4 text-primary" aria-hidden="true" /><span data-testid={`${prefix}-title`}>Season Tickets</span></div>
      {loading ? <Skeleton className="h-8 w-16 mt-1" data-testid={`${prefix}-loading`} /> : <div className="text-2xl font-bold tabular-nums mt-1" data-testid={`${prefix}-total`}>{summary?.season_passes ?? 0}</div>}
      <p className="text-xs text-muted-foreground mt-1" data-testid={`${prefix}-hint`}>One pass per person, not per day QR</p>
    </div>
    <div className="min-w-0 sm:border-l border-border sm:pl-4">
      <p className="text-xs text-muted-foreground" data-testid={`${prefix}-member-label`}>Member season tickets</p>
      {loading ? <Skeleton className="h-7 w-12 mt-1" /> : <p className="text-xl font-semibold tabular-nums mt-1" data-testid={`${prefix}-member-count`}>{summary?.season_member_passes ?? 0}</p>}
    </div>
    <div className="min-w-0 sm:border-l border-border sm:pl-4">
      <p className="text-xs text-muted-foreground" data-testid={`${prefix}-nonmember-label`}>Non-member season tickets</p>
      {loading ? <Skeleton className="h-7 w-12 mt-1" /> : <p className="text-xl font-semibold tabular-nums mt-1" data-testid={`${prefix}-nonmember-count`}>{summary?.season_non_member_passes ?? 0}</p>}
    </div>
    <div className="min-w-0 sm:border-l border-border sm:pl-4">
      <p className="text-xs text-muted-foreground" data-testid={`${prefix}-student-label`}>Student season tickets</p>
      {loading ? <Skeleton className="h-7 w-12 mt-1" /> : <p className="text-xl font-semibold tabular-nums mt-1" data-testid={`${prefix}-student-count`}>{summary?.season_student_passes ?? 0}</p>}
    </div>
  </CardContent>
</Card>;
